import ReportTotalBarChartWidget from "./widgets/DashboardComponents/ReportTotalBarChart/ReportTotalBarChart";
import ReportTotalBarChartWidget_reducer from "./widgets/DashboardComponents/ReportTotalBarChart/reducer";
import ReportTotalBarChartWidget_selectors from "./widgets/DashboardComponents/ReportTotalBarChart/selectors";

import ReportTotalDetailWidget from "./widgets/DashboardComponents/ReportTotalDetail/ReportTotalDetail";
import ReportTotalDetailWidget_reducer from "./widgets/DashboardComponents/ReportTotalDetail/reducer";
import ReportTotalDetailWidget_selectors from "./widgets/DashboardComponents/ReportTotalDetail/selectors";

import DateRangePickerWidget from "./widgets/DashboardComponents/DateRangePicker/DateRangePicker";
import DateRangePickerWidget_reducer from "./widgets/DashboardComponents/DateRangePicker/reducer";
import DateRangePickerWidget_selectors from "./widgets/DashboardComponents/DateRangePicker/selectors";

import UserReportTotalWidget from "./widgets/DashboardComponents/UsersReportTotal/UserReportTotal";
import UserReportTotalWidget_reducer from "./widgets/DashboardComponents/UsersReportTotal/reducer";
import UserReportTotalWidget_selectors from "./widgets/DashboardComponents/UsersReportTotal/selectors";

import BuildExcelDocWidget from "./widgets/DashboardComponents/BuildExcelDoc/BuildExcelDoc";
import BuildExcelDocWidget_reducer from "./widgets/DashboardComponents/BuildExcelDoc/reducer";
import BuildExcelDocWidget_selectors from "./widgets/DashboardComponents/BuildExcelDoc/selectors";

import UserManagerTableDataWidget from "./widgets/UserManagerWidgets/UserManagerTableDataWidget/UserManagerTableData";
import UserManagerTableDataWidget_reducer from "./widgets/UserManagerWidgets/UserManagerTableDataWidget/reducer";
import UserManagerTableDataWidget_selector from "./widgets/UserManagerWidgets/UserManagerTableDataWidget/selectors";

import JobPackProfileInfoWidget from "./widgets/JobPackWidgets/JobPackProfileInfo";
import JobPackProfileAddressWidget from "./widgets/JobPackWidgets/JobPackAddress";
import JobPackProfileAssigneesWidget from "./widgets/JobPackWidgets/JobPackAssignees";

import JobPackProfileUploadFilesWidget from "./widgets/JobPackWidgets/JobPackUploadFiles";
import JobPackProfileAttachedPhotosWidget from "./widgets/JobPackWidgets/JobPackAttachedPhotos";

import JobPackProfileRelatedReportsWidget from "./widgets/JobPackWidgets/RelatedReportsWidget/RelatedReports";
import JobPackProfileRelatedReportsWidget_reducer from "./widgets/JobPackWidgets/RelatedReportsWidget/reducer";
import JobPackProfileRelatedReportsWidget_selector from "./widgets/JobPackWidgets/RelatedReportsWidget/selectors";

import JobPackTrainingRulesWidget from "./widgets/JobPackWidgets/JobPackTrainingRules/JobPackTrainingRules";
import JobPackTrainingRulesWidget_reducer from "./widgets/JobPackWidgets/JobPackTrainingRules/reducer";
import JobPackTrainingRulesWidget_selector from "./widgets/JobPackWidgets/JobPackTrainingRules/selectors";

import JobPackToolboxTalkWidget from "./widgets/JobPackWidgets/JobPackToolboxTalk/JobPackToolboxTalk";
import JobPackToolboxTalkWidget_reducer from "./widgets/JobPackWidgets/JobPackToolboxTalk/reducer";
import JobPackToolboxTalkWidget_selector from "./widgets/JobPackWidgets/JobPackToolboxTalk/selectors";

import UserManagerAddUserWidget from "./widgets/UserManagerWidgets/AddUserWidget/AddUserWidget";
import UserManagerAddUserWidget_reducer from "./widgets/UserManagerWidgets/AddUserWidget/reducer";
import UserManagerAddUserWidget_selector from "./widgets/UserManagerWidgets/AddUserWidget/selectors";

import UserManagerV4TableDataWidget from "./widgets/UserManagerV4Widgets/UserManagerTableDataWidget/UserManagerTableData";
import UserManagerV4TableDataWidget_reducer from "./widgets/UserManagerV4Widgets/UserManagerTableDataWidget/reducer";
import UserManagerV4TableDataWidget_selector from "./widgets/UserManagerV4Widgets/UserManagerTableDataWidget/selectors";

import UserManagerV4AddUserWidget from "./widgets/UserManagerV4Widgets/AddUserWidget/AddUserWidget";
import UserManagerV4AddUserWidget_reducer from "./widgets/UserManagerV4Widgets/AddUserWidget/reducer";
import UserManagerV4AddUserWidget_selector from "./widgets/UserManagerV4Widgets/AddUserWidget/selectors";

import JobPackProfileJobPackAssigneesArrayList from "./widgets/JobPackWidgets/JobPackAssigneesArrayList";

import JobPackSelectReportsWidget from "./widgets/JobPackWidgets/JobPackSelectReports";

import AlertsWidgetReportAlerts from "./widgets/AlertsWidgets/ReportsAlertWidget/ReportsAlertWidget";
import AlertsWidgetReportAlerts_reducer from "./widgets/AlertsWidgets/ReportsAlertWidget/reducer";
import AlertsWidgetReportAlerts_selector from "./widgets/AlertsWidgets/ReportsAlertWidget/selectors";

import AlertsWidgetQualificationAlerts from "./widgets/AlertsWidgets/QualificationsAlertWidget/QualificationsAlertWidget";
import AlertsWidgetQualificationAlerts_reducer from "./widgets/AlertsWidgets/QualificationsAlertWidget/reducer";
import AlertsWidgetQualificationAlerts_selector from "./widgets/AlertsWidgets/QualificationsAlertWidget/selectors";

import JobPackAssigneesArrayListWidget from "./widgets/JobPackWidgets/JobPackAssignessArrayList/JobPackAssigneesArrayList";
import JobPackAssigneesArrayListWidget_reducer from "./widgets/JobPackWidgets/JobPackAssignessArrayList/reducer";
import JobPackAssigneesArrayListWidget_selectors from "./widgets/JobPackWidgets/JobPackAssignessArrayList/selectors";

import JobPackVehicleListWidget from "./widgets/JobPackWidgets/JobPackVehicleList/JobPackVehicleList";
import JobPackVehicleListWidget_reducer from "./widgets/JobPackWidgets/JobPackVehicleList/reducer";
import JobPackVehicleListWidget_selectors from "./widgets/JobPackWidgets/JobPackVehicleList/selectors";

import JobPackEquipmentListWidget from "./widgets/JobPackWidgets/JobPackEquipmentList/JobPackEquipmentList";
import JobPackEquipmentListWidget_reducer from "./widgets/JobPackWidgets/JobPackEquipmentList/reducer";
import JobPackEquipmentListWidget_selectors from "./widgets/JobPackWidgets/JobPackEquipmentList/selectors";

import JobPackGeneralFilesWidget from "./widgets/JobPackWidgets/JobPackGeneralFiles/JobPackGeneralFiles";
import JobPackGeneralFilesWidget_reducer from "./widgets/JobPackWidgets/JobPackGeneralFiles/reducer";
import JobPackGeneralFilesWidget_selectors from "./widgets/JobPackWidgets/JobPackGeneralFiles/selectors";
import JobPackGeneralFilesWidget_types from "./widgets/JobPackWidgets/JobPackGeneralFiles/types";
import JobPackGeneralFilesWidget_actions from "./widgets/JobPackWidgets/JobPackGeneralFiles/actions";

import JobPackMethodStatementsWidget from "./widgets/JobPackWidgets/JobPackMethodStatements/JobPackMethodStatements";
import JobPackMethodStatementsWidget_reducer from "./widgets/JobPackWidgets/JobPackMethodStatements/reducer";
import JobPackMethodStatementsWidget_selector from "./widgets/JobPackWidgets/JobPackMethodStatements/selectors";

import JobPackSelectReports from "./widgets/JobPackWidgets/JobPackSelectReports/JobPackSelectReports";
import JobPackSelectReportsWidget_reducer from "./widgets/JobPackWidgets/JobPackSelectReports/reducer";
import JobPackSelectReportsWidget_selectors from "./widgets/JobPackWidgets/JobPackSelectReports/selectors";
//---------------------------
//------NEW V3 WIDGETS-------
//---------------------------

import NewsBroadcastWidget from "./widgets/DashboardComponents/NewsBroadcast/NewsBroadcast";
import NewsBroadcastWidget_reducer from "./widgets/DashboardComponents/NewsBroadcast/reducer";
import NewsBroadcastWidget_selectors from "./widgets/DashboardComponents/NewsBroadcast/selectors";

import NewsBroadcastV2Widget from "./widgets/DashboardComponents/NewsBroadcastV2/NewsBroadcastV2";
import NewsBroadcastV2Widget_reducer from "./widgets/DashboardComponents/NewsBroadcastV2/reducer";
import NewsBroadcastV2Widget_selectors from "./widgets/DashboardComponents/NewsBroadcastV2/selectors";

import JobPackMapWidget from "./widgets/DashboardComponents/V3/JobPackMapWidget/JobPackMapWidget";
import JobPackMapWidget_reducer from "./widgets/DashboardComponents/V3/JobPackMapWidget/reducer";
import JobPackMapWidget_selectors from "./widgets/DashboardComponents/V3/JobPackMapWidget/selectors";

import UserTotalWidget_reducer from "./widgets/DashboardComponents/V3/UserTotalWidget/reducer";
import UserTotalWidget_selector from "./widgets/DashboardComponents/V3/UserTotalWidget/selectors";
import UserTotalWidget from "./widgets/DashboardComponents/V3/UserTotalWidget/UserTotalWidget";

import ReportTotalWidget_reducer from "./widgets/DashboardComponents/V3/ReportTotalWidget/reducer";
import ReportTotalWidget_selector from "./widgets/DashboardComponents/V3/ReportTotalWidget/selectors";
import ReportTotalWidget from "./widgets/DashboardComponents/V3/ReportTotalWidget/ReportTotalWidget";

import JobPackTotalWidget_reducer from "./widgets/DashboardComponents/V3/JobPackTotalWidget/reducer";
import JobPackTotalWidget_selector from "./widgets/DashboardComponents/V3/JobPackTotalWidget/selectors";
import JobPackTotalWidget from "./widgets/DashboardComponents/V3/JobPackTotalWidget/JobPackTotalWidget";

import ReportMapWidget from "./widgets/DashboardComponents/V3/ReportMapWidget/ReportMapWidget";
import ReportMapWidget_reducer from "./widgets/DashboardComponents/V3/ReportMapWidget/reducer";
import ReportMapWidget_selectors from "./widgets/DashboardComponents/V3/ReportMapWidget/selectors";

import BuildVersionWidget_reducer from "./widgets/DashboardComponents/V3/BuildVersionWidget/reducer";
import BuildVersionWidget_selector from "./widgets/DashboardComponents/V3/BuildVersionWidget/selectors";
import BuildVersionWidget from "./widgets/DashboardComponents/V3/BuildVersionWidget/BuildVersionWidget";

import MessengerWidget_reducer from "./widgets/DashboardComponents/V3/MessengerWidget/reducer";
import MessengerWidget_selector from "./widgets/DashboardComponents/V3/MessengerWidget/selectors";
import MessengerWidget from "./widgets/DashboardComponents/V3/MessengerWidget/MessengerWidget";

import ActivityLogWidget_reducer from "./widgets/DashboardComponents/V3/ActivityLogWidget/reducer";
import ActivityLogWidget_selector from "./widgets/DashboardComponents/V3/ActivityLogWidget/selectors";
import ActivityLogWidget from "./widgets/DashboardComponents/V3/ActivityLogWidget/ActivityLogWidget";

import ProWorkFooter from "./widgets/Headers/ProWorkFooter";
export const widgets = {
    UserTotalWidget,
    MessengerWidget,
    ActivityLogWidget,
    ReportTotalWidget,
    JobPackTotalWidget,
    BuildVersionWidget,
    JobPackVehicleListWidget,
    JobPackEquipmentListWidget,
    ReportMapWidget,
    JobPackMapWidget,
    DateRangePickerWidget,
    ReportTotalBarChartWidget,
    ReportTotalDetailWidget,
    UserReportTotalWidget,
    BuildExcelDocWidget,
    JobPackToolboxTalkWidget,
    UserManagerTableDataWidget,
    JobPackProfileInfoWidget,
    NewsBroadcastWidget,
    NewsBroadcastV2Widget,
    JobPackTrainingRulesWidget,
    UserManagerV4AddUserWidget,
    UserManagerV4TableDataWidget,
    JobPackProfileAddressWidget,
    JobPackProfileAttachedPhotosWidget,
    JobPackProfileAssigneesWidget,
    JobPackProfileUploadFilesWidget,
    JobPackProfileRelatedReportsWidget,
    UserManagerAddUserWidget,
    JobPackProfileJobPackAssigneesArrayList,
    JobPackSelectReportsWidget,
    AlertsWidgetReportAlerts,
    AlertsWidgetQualificationAlerts,
    JobPackAssigneesArrayListWidget,
    JobPackGeneralFilesWidget,
    JobPackMethodStatementsWidget,
    JobPackSelectReports,
    ProWorkFooter,
};
export const reducers = {
    ActivityLogWidget_reducer,
    JobPackMapWidget_reducer,
    UserTotalWidget_reducer,
    ReportTotalWidget_reducer,
    MessengerWidget_reducer,
    ReportMapWidget_reducer,
    JobPackTrainingRulesWidget_reducer,
    JobPackTotalWidget_reducer,
    BuildVersionWidget_reducer,
    JobPackVehicleListWidget_reducer,
    JobPackEquipmentListWidget_reducer,
    ReportTotalBarChartWidget_reducer,
    ReportTotalDetailWidget_reducer,
    DateRangePickerWidget_reducer,
    JobPackToolboxTalkWidget_reducer,
    UserManagerV4TableDataWidget_reducer,
    UserManagerV4AddUserWidget_reducer,
    UserReportTotalWidget_reducer,
    BuildExcelDocWidget_reducer,
    UserManagerTableDataWidget_reducer,
    NewsBroadcastWidget_reducer,
    NewsBroadcastV2Widget_reducer,
    JobPackProfileRelatedReportsWidget_reducer,
    UserManagerAddUserWidget_reducer,
    AlertsWidgetReportAlerts_reducer,
    AlertsWidgetQualificationAlerts_reducer,
    JobPackAssigneesArrayListWidget_reducer,
    JobPackGeneralFilesWidget_reducer,
    JobPackMethodStatementsWidget_reducer,
    JobPackSelectReportsWidget_reducer,
};
export const selectors = {
    JobPackMapWidget_selectors,
    UserTotalWidget_selector,
    ReportTotalWidget_selector,
    JobPackTotalWidget_selector,
    ActivityLogWidget_selector,
    BuildVersionWidget_selector,
    JobPackVehicleListWidget_selectors,
    JobPackEquipmentListWidget_selectors,
    JobPackToolboxTalkWidget_selector,
    MessengerWidget_selector,
    JobPackTrainingRulesWidget_selector,
    DateRangePickerWidget_selectors,
    UserManagerV4TableDataWidget_selector,
    ReportMapWidget_selectors,
    ReportTotalBarChartWidget_selectors,
    UserManagerV4AddUserWidget_selector,
    ReportTotalDetailWidget_selectors,
    UserReportTotalWidget_selectors,
    BuildExcelDocWidget_selectors,
    UserManagerTableDataWidget_selector,
    JobPackProfileRelatedReportsWidget_selector,
    UserManagerAddUserWidget_selector,
    AlertsWidgetReportAlerts_selector,
    AlertsWidgetQualificationAlerts_selector,
    JobPackAssigneesArrayListWidget_selectors,
    JobPackGeneralFilesWidget_selectors,
    NewsBroadcastWidget_selectors,
    NewsBroadcastV2Widget_selectors,
    JobPackMethodStatementsWidget_selector,
    JobPackSelectReportsWidget_selectors,
};

export const types = {
    JobPackGeneralFilesWidget_types,
};
export const actions = {
    JobPackGeneralFilesWidget_actions,
};
